export default __webpack_public_path__ + "static/media/js.7d78ac87.svg";